// extracted by css-extract-rspack-plugin
export default {"participants":"participants-cesSRS","participant":"participant-HuSqtt","buttonGroup":"buttonGroup-UJ4IQp"};